import React from 'react';

export default function OccupationsHeader() {
  return (
    <legend className="mt-8 text-center text-2xl text-column-gray-500 font-semibold">
      Please select your occupation:
    </legend>
  );
}
